export default {"src":"/_next/static/media/star-solid-blue-redesign.b580d15e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};